import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
  adminOnly?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRole,
  adminOnly = false 
}) => {
  const { user, isAuthenticated, isLoading } = useAuth();
  console.log("ProtectedRoute: isAuthenticated =", isAuthenticated, "user =", user);
  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  console.log("ProtectedRoute: isAuthenticated =", isAuthenticated, "user =", user);
  // Check if user is authenticated
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  // Check for admin access
  if (adminOnly) {
    const isAdmin = user.roles?.some((role: any) => role.name === 'admin') || false;
    if (!isAdmin) {
      return <Navigate to="/" replace />;
    }
  }

  // Check for specific role requirement
  if (requiredRole) {
    const hasRole = user.roles?.some((role: any) => role.name === requiredRole) || false;
    if (!hasRole) {
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
